import { MenuDropdown, MenuItem } from '@hakimo-ui/hakimo/ui-elements';
import {
  useCanAddAlarmFeedback,
  useCanReportBug,
} from '@hakimo-ui/hakimo/util';
import { EllipsisVerticalIcon } from '@heroicons/react/24/solid';

interface Props {
  product: 'scan' | 'rg';
  onOpenFeedback: () => void;
  onOpenShareAlarm: () => void;
  onOpenBugReport: () => void;
}

export function PageMenu(props: Props) {
  const { product, onOpenFeedback, onOpenShareAlarm, onOpenBugReport } = props;
  const canReportBug = useCanReportBug();
  const canAddFeedback = useCanAddAlarmFeedback();

  let menuItems: MenuItem[] = [];

  if (product === 'scan') {
    menuItems = [
      {
        name: 'Share alarm',
        onClick: onOpenShareAlarm,
      },
    ];
  } else {
    menuItems = [
      {
        name: 'Share alarm',
        onClick: onOpenShareAlarm,
      },
      {
        name: 'Add feedback',
        onClick: onOpenFeedback,
        hidden: !canAddFeedback,
      },
      {
        name: 'Report bug',
        onClick: onOpenBugReport,
        hidden: !canReportBug,
      },
    ];
  }

  const menuButton = (
    <>
      <span className="sr-only">Open options</span>
      <EllipsisVerticalIcon className="h-6 w-6" aria-hidden="true" />
    </>
  );

  return (
    <div className="flex items-center gap-2">
      <MenuDropdown
        items={menuItems}
        menuButton={menuButton}
        menuButtonTrackingEvent="open_alarm_actions_menu"
      />
    </div>
  );
}

export default PageMenu;
